import React, { useState } from 'react';
import TimezoneOperationhoursCard from './TimezoneOperationhoursCard';
import DatesOverrideCard from './DatesOverrideCard';
import AuthBanner from 'pages/dashboard/CalendarManagePage/components/AuthBanner';
import WelcomeModal from 'pages/dashboard/CalendarPage/components/WelcomeModal';
import DisconnectBanner from './DisconnectBanner';
import { Button, Divider } from 'antd';
import s from './s.module.less';
import { PATH } from 'constants/path';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';
import BookingRestrictions from './BookingRestrictions';
import MinimumTime from './MinimumTime';
import useCalendarConfigSetting from 'hooks/useCalendarConfigSetting';

const AviabilityPage = () => {
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [authStatus, loading, fetchData] = useGoogleAuthStatus();
    const [settingData, settingDataLoading, refetchSettingData] = useCalendarConfigSetting();

    const authBtn = () => {
        return <Button className="mr-2" onClick={() => setShowAuthModal(true)}>Learn more</Button>;
    };
    return (
        <div className={s.wrap}>
            <TimezoneOperationhoursCard />
            <BookingRestrictions
                value={settingData}
                onUpdate={() => {
                    refetchSettingData();
                }}
            />
            <MinimumTime
                value={settingData}
                onUpdate={() => {
                    refetchSettingData();
                }}
            />
            <DatesOverrideCard />
            <div className="bg-white rounded-lg px-7 py-3 mt-7">
                <div className="text-gray-800 text-xl font-medium">Calendar sync</div>
                <Divider />
                {authStatus?.connectSwitch ? <DisconnectBanner onUpdate={fetchData} /> : <AuthBanner successCallbackPath={`${PATH.DASHBOARD}/${PATH.CALENDAR_SETTING}`} actionBtn={authBtn()} />}
            </div>
            {
                showAuthModal && <WelcomeModal isOpen={showAuthModal} onClose={() => setShowAuthModal(false)} step={3} showBackButton={false} />
            }
        </div>
    );
};

export default AviabilityPage;
